(ns teamoesterreich.user-mode.profile.profile-devices
  (:require [clojure.string]
            [goog.date.DateTime]
            [goog.string.format]
            [reagent-material-ui.components :as mui]
            [teamoesterreich.util.log :as log]

            [reagent-material-ui.icons.delete-forever :refer [delete-forever]]
            [reagent-material-ui.icons.keyboard-arrow-left :refer [keyboard-arrow-left]]
            [reagent.core :as r]
            [teamoesterreich.store :as store]
            [teamoesterreich.user-mode.syncer :as syncer]
            [teamoesterreich.text.get-text :as txt]
            [teamoesterreich.user-mode.actions :as a]))


(defn unParseDateFieldToTimestamp [ts]
  (let [date (if ts (.toDate ^js ts) (js/Date.))]
    (goog.string.format "%02d.%02d.%04d" (.getDate date) (inc (.getMonth date)) (.getFullYear date))
    ))


(defn device-block [uuid last-contact model type serial name version]
  (let [name (if (= type "BROWSER") "" name)
        version (if (= type "BROWSER") "aktuell" version)]
    [mui/grid
     {:container false
      :item      true
      :xs        12                                         ;extra-small: 0px
      :style     {:padding "15px 15px 0 15px"}
      }
     [mui/card
      {:variant "outlined"}

      [mui/card-content {

                         }
       (case type
         "BROWSER" [:img {:src "/custom/img/browser.png" :style {:float "right" :width "60px"} :alt "Browser"}]
         "ANDROID" [:img {:src "/custom/img/android.png" :style {:float "right" :width "60px"} :alt "Android"}]
         "iOS" [:img {:src "/custom/img/apple.png" :style {:float "right" :width "60px"} :alt "Apple"}]
         [:span {:src "/custom/img/apple.png" :style {:float "right"} :alt "?"}])

       [mui/typography {:variant "body1" :gutterBottom true} type]
       [mui/typography {:variant "h6" :component "h6"} name]
       [:div
        [mui/typography {:variant "body1" :gutterBottom true}
         "Letzter Kontakt: " (unParseDateFieldToTimestamp last-contact)]
        [:div {:style {:display "inline_block" :float "right" :width "300px"}} "Version: " version " "]]

       ]

      [mui/card-actions
       [mui/button {:size    "small" :color "secondary"
                    :endIcon (r/as-element [delete-forever])
                    } "Löschen"]]

      ]
     ]
    ))


(defn get-it []
  (let [!actual-user (r/cursor store/app-state [:actual-user])
        !user-devices (r/cursor store/app-state [:my-devices])
        !forTomId (r/cursor store/app-state [:my-devices :forTomId])]
    (a/set-bottom-action-fn #(a/set-page-back))
    (syncer/get-devices !actual-user)
    [mui/grid
     {:container  true
      :direction  "column"
      :justify    "center"
      :alignItems "center"
      :spacing    4
      :style      {:marginTop "25px"}
      }
     [mui/grid
      {:container false
       :md        6                                         ;medium: 960px
       :xs        12                                        ;extra-small: 0px
       }
      [mui/paper {:class ""
                  :style {:textAlign "left" :padding "25px"
                          }}
       [mui/grid
        {:container  true
         :direction  "row"
         :justify    "space-between"
         :alignItems "flex-start"
         :spacing    1
         }
        [mui/grid
         {:container false
          :xs        12                                     ;extra-small: 0px
          :style     {:padding "15px"}
          }
         [:h1 {:on-click #(reset! !forTomId -1)}
          "Meine Geräte ..."]
         [:p
          (txt/txt :profile "Du benutzt uns auf folgenden Geräten")
          ]

         ]

        (log/out "########### devices" (clj->js @!user-devices))
        (for [{:keys [uuid last-contact model type serial name version]} (filter #(not (false? (:active %))) (:list @!user-devices))] ;
          ^{:key (str "device-" name)} [device-block uuid last-contact model type serial name version]
          )


        [mui/grid
         {:container false
          :md        5                                      ;medium: 960px
          :xs        5                                      ;extra-small: 0px
          :style     {:padding "15px"}
          }
         [mui/button
          {:variant   "contained"
           :style     {:margin "10px 0 10px 10px" :width "200px"}
           :onClick   #(a/set-page-back)
           :startIcon (r/as-element [keyboard-arrow-left])
           }
          "Zurück"]

         ]

        ]]]]
    ))